'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { useColorScheme } from '@mui/material';
import { Stack } from '@mui/system';

import { AlienDomain, DataFetchResponse } from '@/types/general';
import JsonView from '@/components/core/json-view';

export function JSONTab(): React.JSX.Element {
  const { DOMAIN_DETAILS } = useAppSelector(getDrawerContent);
  const [domainData, setDomainData] = React.useState<AlienDomain>();
  const { colorScheme } = useColorScheme();

  const fetchDomainData = async (): Promise<void> => {
    try {
      const response = await fetch(`/api/devops/domains/list?opId=${DOMAIN_DETAILS?.opId}`, {
        method: 'post',
        body: JSON.stringify({ domainName: DOMAIN_DETAILS?.domainName }),
      });
      const result: DataFetchResponse<AlienDomain> = await response.json();
      if (response.ok && result.success) {
        setDomainData(result.data);
      }
    } catch (e) {
      // empty block
    }
  };

  React.useEffect(() => {
    void fetchDomainData();
  }, []);

  return (
    <Stack direction="column">
      {domainData ? <JsonView src={domainData} theme={colorScheme === 'dark' ? 'monokai' : 'bright:inverted'} /> : null}
    </Stack>
  );
}
